import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

export const SHARE_LOCKED_EVENT = 'share-locked';

const httpLink = createHttpLink({
  uri: '/graphql',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('geodraft_token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      if (extensions?.code === 'UNAUTHENTICATED') {
        // Always drop the stale token, but only kick to /login from pages
        // that need an account. Public pages (share links, transfer accept)
        // probe `me` with whatever token is lying around from a past login —
        // an expired one must not hijack an anonymous visitor's page.
        localStorage.removeItem('geodraft_token');
        const p = window.location.pathname;
        const isPublic = p.startsWith('/share/') || p.startsWith('/transfer/')
          || p === '/login' || p === '/register';
        if (!isPublic) window.location.href = '/login';
      }
      // A share page's unlock grant ran out mid-session: hand control back to
      // ShareGate so the visitor is asked for the password again.
      if (extensions?.code === 'SHARE_PASSWORD_REQUIRED') window.dispatchEvent(new Event(SHARE_LOCKED_EVENT));
      console.error(`[GraphQL error]: ${message}`);
    });
  }
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

export const apolloClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          projects: {
            keyArgs: ['search', 'status'],
            merge(existing = { projects: [] }, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'cache-and-network' },
  },
});
